import React from 'react';
import './modal.scss';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    address: string;
    whatsappLink: string;
    mapsLink: string;
}

const Modal: React.FC<ModalProps> = ({
    isOpen,
    onClose,
    title,
    address,
    whatsappLink,
    mapsLink
}) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>{title}</h2>
                <p>{address}</p>
                <div className="modal-buttons">
                    <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
                        WhatsApp
                    </a>
                    <a href={mapsLink} target="_blank" rel="noopener noreferrer">
                        Ver no mapa
                    </a>
                </div>
                <button className="modal-close" onClick={onClose}>Fechar</button>
            </div>
        </div>
    );
};

export default Modal;
